"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlsFormRatingPicker = void 0;
const DOM_1 = require("../../../../../public/js/utils/DOM");
var ControlsFormRatingPicker;
(function (ControlsFormRatingPicker) {
    class Config {
        static inputContainerClass = "RatingPicker";
        static valueDataName = "value";
        static filledClassName = "filled";
        static notFilledClassName = "notFilled";
        static selectedClassName = "selected";
        static inputClassName = "RatingPicker-input";
    }
    class Control {
        static initialize(container) {
            const inputs = DOM_1.DOM.Parser.getHtmlElements(Config.inputContainerClass, container, true);
            for (let i = 0; i < inputs.length; i++) {
                this.initializeElement(inputs[i]);
            }
        }
        static initializeElement(element) {
            const triggers = DOM_1.DOM.Parser.getHtmlElementsByQuery('i', element);
            const input = DOM_1.DOM.Parser.getHtmlElementByClass(Config.inputClassName, element);
            for (let i = 0; i < triggers.length; i++) {
                const trigger = triggers[i];
                trigger.addEventListener('click', () => { this.triggerClick(input, trigger, element, triggers); });
                trigger.addEventListener('mouseenter', () => { this.triggerEnter(trigger, element, triggers); });
                trigger.addEventListener('mouseleave', () => { this.triggerLeave(triggers); });
            }
        }
        static triggerClick(input, trigger, element, triggers) {
            const triggerValue = parseInt(DOM_1.DOM.Parser.getDataByNameFromElement(Config.valueDataName, trigger));
            input.value = triggerValue.toString();
            input.dispatchEvent(new Event('change'));
            for (let i = 0; i < triggers.length; i++) {
                triggers[i].classList.remove(Config.selectedClassName);
            }
            for (let x = 1; x <= triggerValue; x++) {
                DOM_1.DOM.Parser.getHtmlElementByQuery(`[data-value="${x}"]`, element).classList.add(Config.selectedClassName);
            }
        }
        static triggerEnter(trigger, element, triggers) {
            const triggerValue = parseInt(DOM_1.DOM.Parser.getDataByNameFromElement(Config.valueDataName, trigger));
            for (let i = 0; i < triggers.length; i++) {
                triggers[i].classList.remove(Config.filledClassName);
                triggers[i].classList.add(Config.notFilledClassName);
            }
            for (let x = 1; x <= triggerValue; x++) {
                const current = DOM_1.DOM.Parser.getHtmlElementByQuery(`[data-value="${x}"]`, element);
                current.classList.add(Config.filledClassName);
                current.classList.remove(Config.notFilledClassName);
            }
        }
        static triggerLeave(triggers) {
            for (let i = 0; i < triggers.length; i++) {
                triggers[i].classList.remove(Config.filledClassName);
                triggers[i].classList.remove(Config.notFilledClassName);
            }
        }
    }
    ControlsFormRatingPicker.Control = Control;
})(ControlsFormRatingPicker || (exports.ControlsFormRatingPicker = ControlsFormRatingPicker = {}));
